import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";

import LandingPage from "./LandingPage";
import Signup from "./Signup";
import Login from "./Login";
import Dashboard from "./Dashboard";
import SpecialtySelection from "./SpecialtySelection";
import TablePage from "./TablePage";
import ObservershipsPage from './ObservershipsPage';
import SetupProfile from "./SetupProfile";
import SelectedCriteria from "./SelectedCriteria";
import ProfileSettings from "./ProfileSettings";
import AdminDashboard from "./AdminDashboard";
import UploadHistory from "./UploadHistory";
import ComparePage from "./ComparePage";
import HowdidPage from './HowdidPage';

// ✅ NEW: Import pages from src/pages/
import FeaturesPage from "./pages/FeaturesPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import PricingPage from "./pages/PricingPage";
import APIPage from "./pages/APIPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import HelpCenterPage from "./pages/HelpCentrePage";
import AboutPage from "./pages/AboutPage"; 
import RefundPolicy from './pages/RefundPolicy';
import CancellationPolicy from './pages/CancellationPolicy';

// ✅ NEW: Import AuthProvider
import { AuthProvider, useAuth } from "./AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

// 🔁 Role-Based Redirect Component (for authenticated users)
function RoleBasedRedirect() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkUserRole = async () => {
      if (loading) return; // Wait for auth to finish loading
      
      if (user) {
        try {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
          const role = docSnap.exists() ? docSnap.data().role : "user";

          if (role === "admin") {
            navigate("/admin/upload");
          } else {
            navigate("/dashboard");
          }
        } catch (err) {
          console.error("Error checking role:", err);
          navigate("/login");
        }
      } else {
        navigate("/home");
      }
      setChecking(false);
    };

    checkUserRole();
  }, [navigate, user, loading]);

  return (loading || checking) ? <div style={{ padding: "30px" }}>🔄 Checking role...</div> : null;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/home" element={<LandingPage />} />

      {/* ✅ Product Pages */}
      <Route path="/features" element={<FeaturesPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/api" element={<APIPage />} />

      {/* ✅ Support Pages */}
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/help" element={<HelpCenterPage />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/cancellation-policy" element={<CancellationPolicy />} />

      {/* ✅ Company Pages */}
      <Route path="/about" element={<AboutPage />} /> 

      <Route path="/app" element={<RoleBasedRedirect />} />

      <Route path="/signup" element={<Signup />} />
      <Route path="/how-did-you-find-us" element={<HowdidPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/setup-profile" element={<SetupProfile />} />

      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/my-lists" element={<SpecialtySelection />} />
      <Route path="/criteria" element={<SelectedCriteria />} />
      <Route path="/profile-settings" element={<ProfileSettings />} />
      <Route path="/observerships" element={<ObservershipsPage />} />
      <Route path="/table/:specialty" element={<TablePage />} />

      {/* ✅ ComparePage Route */}
      <Route path="/compare/:collegeId" element={<ComparePage />} />

      <Route path="/admin/upload" element={<AdminDashboard />} />
      <Route path="/admin/history" element={<UploadHistory />} />

      <Route path="*" element={<div style={{ padding: 40 }}>404 - Page Not Found</div>} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;